export const salesStatuses = {
  PROSPECT: "prospect",
  INTRO: "intro",
  FIRST_MEETING: "firstMeeting",
  RFQ_RECEIVED: "rfqReceived",
  AUDIT: "audit",
  AWARD_PENDING: "awardPending"
  // DEAD: 7
};
